import Swiper from"../Swiper";/**
 * The basic slider component.
 * @param {Object} props The component properties.
 * @deprecated
 */var Slider=Swiper;export default Slider;